import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {first, takeUntil} from 'rxjs/operators';
import {UserService} from '../../../shared/services/user.service';
import {HttpErrorResponse} from '@angular/common/http';
import {User} from '../../../shared/interface/user';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {
  DictService, PERMISSIONS_TYPE,
} from "../../../shared/services/dict.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {Regional} from "../../../shared/interface/regional";
import {PermissionsTag} from "../../../shared/interface/permissions-tag";
import {Post} from "../../../shared/interface/post";
import {RegionalService} from "../../../shared/services/regional.service";
import {PermissionTagsService} from "../../../shared/services/permission-tags.service";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {InsuranceCompanyService} from "../../../shared/services/insurance-company.service";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit, OnDestroy {

  userId: string;
  userObject?: User;
  userSummaryPermissions: any;
  user: ReplaySubject<User> = new ReplaySubject<User>(1);
  modify = false;
  userPermissionsForm: FormGroup;
  userPermissionsApplicationForm: FormGroup;
  userPermissions: ReplaySubject<UserPermissions>;
  reportPermissionsControl: FormControl;
  userReportPermissionsForm: FormGroup;
  userApplicationPermissionsForm: FormGroup;
  userRaporValue:   string[] = [];

  permissionTagPartner: Dictionary[] = [];
  permissionRegistration: InsuranceCompany[] = [];
  permissionContractType: Dictionary[] = [];
  permissionIddTrainingStatus: Dictionary[] = [];
  permissionRegional: Regional[] = [];
  permissionTag: PermissionsTag[] = [];
  selectedTab: number;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private fb: FormBuilder,
    private auth: AuthService,
    private regionalsService: RegionalService,
    private privateTagsService: PermissionTagsService,
    private insuranceCompanyService: InsuranceCompanyService
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.userPermissionsForm = fb.group({});
    this.userPermissionsApplicationForm = fb.group({});
    this.userApplicationPermissionsForm = fb.group({});
    this.userReportPermissionsForm = fb.group({
      reportPermissions: this.reportPermissionsControl = fb.control([]),
    });
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.userId = params.id;
        this.loadUser();
        this.userService.getUserPermissions(this.userId)
          .subscribe((permissions) => this.userSummaryPermissions = permissions);
      });
  }

  loadPermision(user: User): void {
    this.permissionTagPartner = [];
    user.permissionTagPartner.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionTagPartner.push(dict);
        });
    });
    this.permissionContractType = [];
    user.permissionContractType.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionContractType.push(dict);
        });
    });
    this.permissionRegional = [];
      this.regionalsService.get(user.permissionRegionalId)
        .pipe(first())
        .subscribe((regional: Regional) => {
          this.permissionRegional.push(regional);
        });
    this.permissionIddTrainingStatus = [];
    user.permissionIddTrainingStatus.forEach((dictId: number) => {
      this.dictService.getDict(dictId)
        .subscribe((dict: Dictionary) => {
          this.permissionIddTrainingStatus.push(dict);
        });
    });
    this.permissionTag = [];
    user.permissionTag.forEach((tagId: number) => {
      this.privateTagsService.getDict(tagId)
        .subscribe((dict: PermissionsTag) => {
          this.permissionTag.push(dict);
        });
    });
    this.permissionRegistration = [];
    this.insuranceCompanyService.loadList(0, 1000, {});
    this.insuranceCompanyService.getInsuranceCompaniesPageSubject()
      .pipe(first())
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        result.items.forEach((insuranceCompany: InsuranceCompany) => {
          if ( user.permissionRegistration.includes(insuranceCompany.id)) {
            this.permissionRegistration.push(insuranceCompany);
          }
        });

      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadUser(): void {
    this.selectedTab = 0;
    this.userService.get(this.userId).subscribe((user: User) => {
      this.user.next(user);
      this.userObject = user;
      this.loadPermision(user);

      this.reportPermissionsControl.setValue(user.reportPermissions);
      this.reportPermissionsControl.value.forEach((key: string) => {
        this.dictService.get(key, PERMISSIONS_TYPE)
          .subscribe((dict: Dictionary) => {
            this.userRaporValue.push(dict.name);
          });
      });
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
        duration: 2000
      });
    });
  }

  savePermissions(): void {
    this.userService.updatePermissions(this.userObject.uuid, this.userPermissionsForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia', '', {
          duration: 2000,
        });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  savePermissionsApplication(): void {
    this.userService.updatePermissionsApplications(this.userObject.uuid, this.userPermissionsApplicationForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia', '', {
          duration: 2000,
        });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  saveReportPermissions(): void {
    this.userService.updateReportPermissions(this.userObject.uuid, this.userReportPermissionsForm.getRawValue())
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia raportów', '', {
          duration: 2000,
        });

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień raportów wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }
  saveApplicationPermissions(): void {
    if (!this.userApplicationPermissionsForm || !this.userObject) {
      return;
    }

    const payload = this.userApplicationPermissionsForm.getRawValue();

    this.userService.updateApplicationPermissions(
      this.userObject.uuid,
      payload
    )
      .pipe(first())
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano uprawnienia aplikacji', '', {
          duration: 2000,
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas aktualizacji uprawnień aplikacji wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }
  getDepartmentEmployeeApplicationPermissions(): any {
    return this.normalizeDepartmentApplicationPermissions(
      this.userObject?.department?.applicationPermissions,
      'employee'
    );
  }

  getDepartmentSupervisorApplicationPermissions(department: any): any {
    return this.normalizeDepartmentApplicationPermissions(
      department?.applicationPermissions,
      'supervisor'
    );
  }

  private normalizeDepartmentApplicationPermissions(
    applicationPermissions: any,
    assignmentType: 'employee' | 'supervisor'
  ): any {
    const result = {};

    if (!applicationPermissions || !Array.isArray(applicationPermissions)) {
      return result;
    }

    applicationPermissions
      .filter((item: any) => item.assignmentType === assignmentType)
      .forEach((item: any) => {
        result[item.applicationKey] = item.permissions || {};
      });

    return result;
  }

  hasDepartmentApplicationPermissions(): boolean {
    return !!this.userObject?.department;
  }
}
